// @flow

import CardLeagueList from './CardLeagueList'

export default CardLeagueList
